import { render, staticRenderFns } from "./Photograph.vue?vue&type=template&id=28ac50df&scoped=true&v-slot%3Acontent=true&"
import script from "./Photograph.vue?vue&type=script&lang=ts&"
export * from "./Photograph.vue?vue&type=script&lang=ts&"
import style0 from "./Photograph.vue?vue&type=style&index=0&id=28ac50df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac50df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow})
